import React from 'react';
import PropTypes from 'prop-types';
import HomePage from 'components/HomePage';

const propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.any.isRequired,
};

function HomePageContainer({ data }) {
  return <HomePage data={data} />;
}

HomePageContainer.propTypes = propTypes;

export default HomePageContainer;

export const query = graphql`
  query PageQuery {
    contentfulHomepage {
      caseStudyHeading
      caseStudySubheading
      caseStudies {
        id
        slug
        heading
        subHeading
        cardImage {
          responsiveResolution(width: 800) {
            width
            height
            src
            srcSet
          }
        }
      }
      heroHeading
      heroImage {
        fullSize: resolutions(width: 1856) {
          src
        }
        thumbnail: resolutions(width: 20, height: 20) {
          base64
        }
      }
      heroButtonText
      heroTypingValues
      seoDescription {
        seoDescription
      }
      seoKeywords
      seoTitle
      serviceDetails {
        id
        ctaText
        ctaLink
        headingText
        bodyText {
          bodyText
        }
        sideImage {
          fullSize: resolutions(width: 900) {
            src
          }
        }
      }
      videoHeading
      videoSubheading
      videoThumbnail {
        fullSize: resolutions(width: 1856) {
          src
        }
        thumbnail: resolutions(width: 20, height: 20) {
          base64
        }
      }
      videoButtonText
      testimonials {
        id
        name
        position
        testimonial {
          text: testimonial
        }
        logo {
          fullSize: resolutions(width: 330) {
            src
          }
        }
      }
    }

    allContentfulCaseStudy(filter: { node_locale: { eq: "en-US" } }) {
      edges {
        node {
          id
          slug
          heading
          subHeading
          cardImage {
            responsiveResolution(width: 800) {
              src
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js